import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ForgetPasswordBlocks {
  EMAIL = 'email',
  PASSWORD = 'password',
  SUCCESS = 'success',
}

type ForgetPasswordState = {
  block: ForgetPasswordBlocks;
  email: string | undefined;
  code: string | undefined;
  password: string | undefined;
  error: string | undefined;
  loading: boolean;
};

const initialState: ForgetPasswordState = {
  block: ForgetPasswordBlocks.EMAIL,
  email: undefined,
  code: undefined,
  password: undefined,
  error: undefined,
  loading: false,
};

const forgetPasswordSlice = createSlice({
  name: 'forgetPassword',
  initialState,
  reducers: {
    resetForgetPasswordState: (state) => ({ ...initialState, email: state.email }),
    setForgetPasswordError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setForgetPasswordEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
      state.loading = true;
    },
    sendForgetPasswordEmailSuccess: (state) => {
      state.block = ForgetPasswordBlocks.PASSWORD;
      state.loading = false;
    },
    setForgetPasswordCode: (state, action: PayloadAction<string>) => {
      state.code = action.payload;
    },
    setForgetPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
      state.loading = true;
    },
    setNewPasswordSuccess: (state) => {
      state.loading = false;
      state.block = ForgetPasswordBlocks.SUCCESS;
    },
  },
});

export const {
  resetForgetPasswordState,
  setForgetPasswordEmail,
  setForgetPasswordCode,
  setForgetPassword,
  setForgetPasswordError,
  sendForgetPasswordEmailSuccess,
  setNewPasswordSuccess,
} = forgetPasswordSlice.actions;

export default forgetPasswordSlice.reducer;
